<template>
	<div>
		<div>
			<div style="display: flex; width: 100%">
				<div style="width: 85%; margin-top: 5px; display: flex">
					<div><h3>Failed</h3></div>
					<div style="color: red; margin-left: 10px">
						{{ storeObj.failed_count }} of {{ storeObj.total }} ({{
							((storeObj.failed_count / storeObj.total) * 100).toFixed(2)
						}}%)
					</div>
				</div>

				<div style="margin-left: auto">
					<el-button
						icon="el-icon-download"
						style="margin-top: 0px; margin-left: 20px"
						class="button-class-new"
						@click="exportCSVcriticalQuestionsData()"
					>
						Download Reports
					</el-button>
				</div>
			</div>
			<el-row class="critical-questions-falied-table" style="margin-top: 10px">
				<el-col :span="24">
					<el-table
						:loading="loading"
						class="responsive-table"
						style="
							text-transform: capitalize;
							word-break: break-word;
							width: 100%;
						"
						:data="
							computedCriticalQuestionsData.filter(
								(el, index) => index >= startNumber - 1 && index < endNumber
							)
						"
					>
						<el-table-column width="120px" label="Date">
							<template slot-scope="scope">
								<div>
									{{
										scope.row.completion_date != null
											? moment(scope.row.completion_date).format("Do MMM YYYY")
											: "-"
									}}
								</div>
							</template>
						</el-table-column>
						<el-table-column width="400px" label="Question">
							<template slot-scope="scope">
								<div style="text-transform: capitalize; word-break: break-word">
									{{
										scope.row.form_question_execution_info &&
										scope.row.form_question_execution_info.form_question_info
											? scope.row.form_question_execution_info
													.form_question_info.name
											: ""
									}}
								</div>
							</template>
						</el-table-column>
						<el-table-column width="120px" label="Input">
							<template slot-scope="scope">
								<div style="color: red">
									{{ getUserInputValues(scope.row) }}
								</div>
							</template>
						</el-table-column>
						<el-table-column width="290px" label="Comment">
							<template slot-scope="scope">
								<div style="text-transform: capitalize; word-break: break-word">
									{{
										scope.row.form_question_execution_info
											? scope.row.form_question_execution_info.comment != null
												? scope.row.form_question_execution_info.comment
												: "-"
											: "-"
									}}
								</div>
							</template>
						</el-table-column>
						<el-table-column width="350px" label="Attachments">
							<template slot-scope="scope">
								<div
									v-if="
										scope.row.form_question_execution_info
											.form_question_execution_attachments.length
									"
								>
									<div class="attachments-container">
										<div
											v-for="(attachment, index) in displayedAttachments(
												scope.row.form_question_execution_info
													.form_question_execution_attachments
											)"
											:key="attachment.id"
										>
											<img
												@click="
													openAttachmentsDialog(
														scope.row.form_question_execution_info
															.form_question_execution_attachments,
														scope.row
													)
												"
												:src="attachmentsMap[attachment.id] || ''"
												v-if="attachmentsMap[attachment.id]"
												style="width: 80px; height: 80px; margin-right: 10px"
											/>
											<span v-else>Loading...</span>
											<span v-if="!attachmentsMap[attachment.id]">{{
												getImages(attachment.file_path, attachment.id)
											}}</span>
										</div>
										<div
											v-if="
												remainingAttachments(
													scope.row.form_question_execution_info
														.form_question_execution_attachments
												) > 0
											"
											style="color: #d26300; margin-top: 30px"
										>
											+{{
												remainingAttachments(
													scope.row.form_question_execution_info
														.form_question_execution_attachments
												)
											}}
											more
										</div>
									</div>
								</div>
								<div v-else>No attachments</div>
							</template>
						</el-table-column>
						<el-table-column prop="status" label="Status">
							<template slot-scope="scope">
								<el-tag
									size="small"
									style="border-radius: 12px; width: 80px; text-align: center"
									:style="
										scope.row.status == 'completed'
											? 'border-color:#41BE62; background-color:#FFF9F4; color:#41BE62'
											: 'border-color:#D26300; background-color:#FFF9F4; color:#D26300'
									"
									>{{
										scope.row.status == "completed" ? "Completed" : "Inprogress"
									}}
								</el-tag>
							</template>
						</el-table-column>
					</el-table>
				</el-col>
			</el-row>
			<el-row :gutter="10" class="mt-3">
				<el-col :span="8" class="text-left">
					<div>
						<b>Showing</b> {{ startNumber }} to {{ endNumber }} of
						{{ computedCriticalQuestionsData.length }} results
					</div>
				</el-col>
				<el-col :span="8" class="text-center">
					<el-select
						v-model="perPage"
						name="per_page"
						placeholder="select per page"
						style="width: 90px !important"
						size="mini"
					>
						<el-option label="10" :value="10"></el-option>
						<el-option label="25" :value="25"></el-option>
						<el-option label="50" :value="50"></el-option>
						<el-option label="100" :value="100"></el-option>
					</el-select>
					&nbsp;<b>per page</b>
				</el-col>
				<el-col :span="8" class="text-right">
					<el-pagination
						background
						layout="prev, pager, next"
						:total="computedCriticalQuestionsData.length"
						:page-size="perPage"
						:current-page.sync="currentPage"
					></el-pagination>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
var moment = require("moment");
import formBuilderServices from "../../../../services/formBuilderServices";
import exportFromJSON from "export-from-json";
export default {
	props: {
		ByLocationCriticalQuestionData: Array,
		projectsTasks: String,
		projectsTasksItems: Array,
		dates: Array,
		storeObj: Object,
	},
	data: () => ({
		perPage: 10,
		currentPage: 1,
		moment: moment,
		attachmentsMap: {},
		fileURLArray: [],
		loading: false,
	}),
	computed: {
		computedCriticalQuestionsData() {
			let arr = [...this.ByLocationCriticalQuestionData];
			return arr;
		},
		startNumber() {
			let start = this.currentPage * this.perPage - (this.perPage - 1);
			return start;
		},
		endNumber() {
			let end = Math.min(
				this.startNumber + this.perPage - 1,
				this.computedCriticalQuestionsData.length
			);
			return end;
		},
	},
	methods: {
		...mapActions("CommonStore", [
			"addDownloadingReportCountAction",
			"removeDownloadingReportCountAction",
		]),
		async openAttachmentsDialog(arr, item) {
			for (let [index, el] of arr.entries()) {
				el.fileDetails = {
					name: "",
				};
				let params = {
					file_path: el.file_path,
					storage: "task",
				};
				await formBuilderServices.getAttachmentURL(params).then((res) => {
					el.src = JSON.parse(res.data).data;
				});
				el.fileDetails = {
					name: el.file_name,
				};
			}
			this.fileURLArray = arr;
			this.$emit("showPreviewByLocationAttachments", this.fileURLArray, item);
			this.$forceUpdate();
		},
		getImages(paths, attachmentId) {
			this.loading = true;
			let params = {
				file_path: paths,
				storage: "task",
			};
			formBuilderServices.getAttachmentURL(params).then((res) => {
				let results = JSON.parse(res.data).data;
				this.$set(this.attachmentsMap, attachmentId, results);
				this.loading = false;
				this.$forceUpdate();
			});
		},
		displayedAttachments(attachments) {
			return attachments.slice(0, 3);
		},
		remainingAttachments(attachments) {
			return attachments.length > 3 ? attachments.length - 3 : 0;
		},
		getUserInputValues(item) {
			if (
				item &&
				item.form_question_execution_info &&
				item.form_question_execution_info.form_question_info &&
				item.form_question_execution_info.form_question_info.input_type_info
					.name === "Yes / No"
			) {
				return item.form_question_execution_info.boolean_input ? "Yes" : "No";
			}
		},
		exportCSVcriticalQuestionsData() {
			this.addDownloadingReportCountAction("Report");
			let data = null;
			data = this.ByLocationCriticalQuestionData.map((el) => {
				let attachmentUrls = "-";
				if (
					el.form_question_execution_info &&
					el.form_question_execution_info.form_question_execution_attachments &&
					el.form_question_execution_info.form_question_execution_attachments
						.length > 0
				) {
					attachmentUrls =
						el.form_question_execution_info.form_question_execution_attachments
							.map((attachment) =>
								attachment.file_path
									? `https://nymbleup-tasks-attachments.s3.amazonaws.com/${attachment.file_path}`
									: "-"
							)
							.join(", "); // Combine multiple URLs into a single string separated by commas or any desired separator
				}

				const item = {
					Date:
						el.completion_date != null
							? moment(el.completion_date).format("Do MMM YYYY")
							: "-",
					Questions:
						el.form_question_execution_info &&
						el.form_question_execution_info.form_question_info &&
						el.form_question_execution_info.form_question_info.name
							? el.form_question_execution_info.form_question_info.name
							: "-",
					"Input Type": this.getUserInputValues
						? this.getUserInputValues(el)
						: "-",
					Attachments: attachmentUrls,
					Comment:
						el.form_question_execution_info &&
						el.form_question_execution_info.comment
							? el.form_question_execution_info.comment
							: "-",
					Status: el.status || "-",
				};
				return item;
			});
			const fileName = `Critical Questions Data  ${
				this.projectsTasksItems.length != 0
					? this.projectsTasksItems.filter((el) =>
							el.id.includes(this.projectsTasks)
					  )[0].name
					: "-"
			} ( ${this.moment(this.dates[0]).format("Do MMM YYYY")} - ${this.moment(
				this.dates[1]
			).format("Do MMM YYYY")} )`;
			const exportType = exportFromJSON.types.csv;
			exportFromJSON({ data, fileName, exportType });
			this.removeDownloadingReportCountAction();
		},
	},
};
</script>

<style>
.attachments-container {
	display: flex;
	flex-wrap: wrap; /* Optional: wrap to next line if too long */
}
</style>
